import { Checkbox, FormattedDateTime, TableTd, TableTr } from '@customerio/pluma-components/react';
import type { Relationship } from '@customerio/hydra-ui-api';
import { formatNumberAndPluralize } from '@/utils/number';
import { RelationshipAttributeCountCell, RelationshipPersonCell, RelationshipViewCell } from './relationship-cells';

export type RelationshipRowModel = {
  key: string;
  relationship: Relationship;
  /** Position on the current page; the checkbox name, aria-label and range selection all key on it. */
  index: number;
  personName: string | undefined;
  personHref: string | undefined;
  isSelected: boolean;
};

type RelationshipRowProps = {
  row: RelationshipRowModel;
  canSelect: boolean;
  onSelectedChange: (checked: boolean) => void;
  /** Absent until the attribute preview drawer lands, which is when the cells become links. */
  onView: (() => void) | undefined;
};

export function RelationshipRow({ row, canSelect, onSelectedChange, onView }: RelationshipRowProps) {
  const { relationship, index, personName, personHref } = row;
  const attributeCount = Object.keys(relationship.attributes).length;

  return (
    <TableTr data-test-relationships-table-entry>
      <TableTd py="0">
        <Checkbox
          name={`check_${index}`}
          isDisabled={!canSelect}
          isChecked={row.isSelected}
          onCheckedChange={onSelectedChange}
          ariaLabel={`Select relationship ${index}`}
        />
      </TableTd>
      <RelationshipPersonCell personName={personName} personHref={personHref} />
      <RelationshipAttributeCountCell
        label={formatNumberAndPluralize(attributeCount, 'attribute')}
        ariaLabel={`View relationship attributes for ${personName ?? `relationship ${index}`}`}
        onView={onView}
      />
      <TableTd textAlign="right">
        <FormattedDateTime date={relationship.created_at} withRelativeDateFromNow withTooltip />
      </TableTd>
      <RelationshipViewCell onView={onView} />
    </TableTr>
  );
}
